import { __assign, __extends } from "tslib";
import * as React from 'react';
import { Box, TextButton, Text } from 'wix-style-react';
var ChildrenWrapper = function (_a) {
    var children = _a.children;
    return children;
};
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false, error: null };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error("Inbox Error Rendering Component: " + this.props.displayName, error, errorInfo);
        if (window.Sentry) {
            window.Sentry.withScope(function (scope) {
                scope.setExtra('componentStack', errorInfo);
                window.Sentry.captureException(error);
            });
        }
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return (React.createElement(Box, { dataHook: "inbox-error-boundary", align: "center", verticalAlign: "middle", direction: "vertical" },
                React.createElement(Text, { skin: "error", size: "tiny", dataHook: "inbox-error-boundary-text" }, "Error in " + this.props.displayName),
                React.createElement(TextButton, { as: "a", size: "tiny", target: "_blank", href: "https://www.wix.com/contact" }, "Contact support")));
        }
        return React.createElement(ChildrenWrapper, null, this.props.children);
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
export var withErrorBoundary = function (displayName, Wrapped) {
    return function (props) {
        return (React.createElement(ErrorBoundary, { displayName: displayName },
            React.createElement(Wrapped, __assign({}, props))));
    };
};
//# sourceMappingURL=ErrorBoundary.js.map